import React, { createContext, useCallback, useContext, useState } from 'react';

const ItemMarketContext = createContext(null);

export const ItemMarketProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openMarket = useCallback(() => setIsOpen(true), []);
  const closeMarket = useCallback(() => setIsOpen(false), []);

  return (
    <ItemMarketContext.Provider value={{ isOpen, openMarket, closeMarket }}>
      {children}
    </ItemMarketContext.Provider>
  );
};

export const useItemMarket = () => {
  const context = useContext(ItemMarketContext);
  if (!context) {
    throw new Error('useItemMarket must be used within ItemMarketProvider');
  }
  return context;
};
